import {animateCubicBezier} from './utils'
import ScrollObserver from "./scroll-observer";

export default function (el) {
    const ranges = document.querySelectorAll('.image-comparator__range')
    ranges.forEach(range => {
        range.addEventListener('input', () => {
            el.style.setProperty("--range-progress", `${range.value}%`);
            ranges.forEach(el => el.value = range.value)
        })
    })
    ScrollObserver([el], () => {
        const inputs = el.querySelectorAll('.image-comparator__range')

        inputs.forEach(input => {
            animateCubicBezier((position) => {
                el.style.setProperty("--range-progress", `${position.x}%`);
                input.value = position.x;
            }, [], 1000);
        })
    }, {rootMargin: "0px 0px", threshold: 1})
}
